import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { AnnouncementSelect as LocalAnnouncementSelect } from '../../components/AnnouncementSelect'

export const AnnouncementSelect = connect(
  LocalAnnouncementSelect,
  mapReadPretty(LocalAnnouncementSelect, {
    disabled: true
  })
)
